import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { benchmarkkpi, tranbenchmarkkpi } from '../../../models/slakpi';
import { division, user, department, targetMaster, benchmarkprogressmaster } from '../../../models/admin';
import { incomingBMRequest } from '../../../models/slakpi';
import { UtilityService } from '../../../services/utility.service';
import { BMApiService } from '../../../services/bm.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { UserService } from '../../../services/user.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { uniqBy } from 'lodash';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AdminApiService } from '../../../services/admin.service';
import { ToasterService } from '../../../toaster.service';

@Component({
  selector: 'app-incoming-bm-request-master',
  templateUrl: './incoming-bm-request-master.component.html',
  styleUrls: ['./incoming-bm-request-master.component.css']
})
export class IncomingBMRequestMasterComponent implements OnInit {
  public gridApi: any;
  public gridColumnApi: any;
  public columnDefs: any;
  public defaultColDef: any;
  public rowData: any;
  public PopoverModule;
  modalRef: BsModalRef;
  @ViewChild('addtemplate', { static: false }) addtemplate: TemplateRef<any>;
  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset: any;
  public selTab = true;
  public data: any;
  public gridload: number = 0;
  submitted: boolean = false;

  invalid: boolean = false;
  public loading: boolean = true;
  public pageAction: string = 'add';
  objIncomingRequest: any = new incomingBMRequest();
  angularGrid: AngularGridInstance;
  bmProgressMasterData: object[];
  selected_itemUno: number = 0;
  pfmType: any;
  isTitle: boolean = false;
  continentDDList: any = [];
  isContinentDD: boolean = false;
  titleName: string;
  Title2: boolean;
  countryDDList: any;
  isCountryDD: boolean = false;
  isRegionDD: boolean = false;
  sourceTypeDDList: any = [];
  regionDDList: any = [];
  isSourceTypeDD: boolean = false;
  isSourceDesc: boolean = false;
  utilityTypeDDList: any = [];
  peerTypeDDList: any = [];
  isUtilityTypeDD = false;
  isPeerTypeDD = false;
  isBusinessModel: boolean = false;
  isTechnologyUsed: boolean = false;
    bmProgressTypeDDList: Object;
    division_data: Object;
  department_data: Object;
  statusDDList = [{ value: 1, text: 'Draft' }, { value: 2, text: 'Submitted' }];
  userList: any;
    login_UserID: any;
    editID: any;
    searchText: string;
  constructor(private formBuilder: FormBuilder, public restApi: AdminApiService,
    public restBMApi: BMApiService,private route: ActivatedRoute,
    public utilityService: UtilityService, private router: Router, private toaster: ToasterService,private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService) { }

  ngOnInit() {

    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    this.userList = this.userService.getUserInfo();
    this.login_UserID = this.userList.id;
    this.searchText = '';
    this.loadInComingBMRequestMaster();
    this.getDepartments();
    this.getDivisions();

  }


  getDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = 1;
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {
        
        this.division_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  getDepartments() {

    let inpValue = new department();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;
    this.restApi.getDepartments(inpValue)
      .subscribe(data => {
        
        this.department_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
  }
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' ';

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' ';

  }
  


  setGridIncomingBMRequestMasterDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'kpiName', name: 'KPI Name', field: 'kpiName', sortable: true, type: FieldType.string, filterable: true, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiName', 'kpiName'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'kpiDescr', name: 'KPI Description', field: 'kpiDescr', sortable: true, type: FieldType.string, filterable: true, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiDescr', 'kpiDescr'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'kpiFormula', name: 'KPI Formula', field: 'kpiFormula', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiFormula', 'kpiFormula'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'kpiRepVehicle', name: 'KPI Rep Vehicle', field: 'kpiRepVehicle', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiRepVehicle', 'kpiRepVehicle'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'targetGeoArea', name: 'Target Geo Area', field: 'targetGeoArea', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'targetGeoArea', 'targetGeoArea'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'reasonforKPISelection', name: 'Reason for KPI Selection', field: 'reasonforKPISelection', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'reasonforKPISelection', 'reasonforKPISelection'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'status', name: 'Status', field: 'status', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'status', 'status'),
          model: Filters.multipleSelect,

        }
      },

      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 20,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Edit',
              iconCssClass: 'fa fa-pencil-square-o', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                

                let rdata: any = args.dataContext;
                this.editID = rdata.id;
                this.objIncomingRequest = rdata;
                this.selTab = true;

              

                if (this.pageAction == 'edit') {
                  
                  this.selected_itemUno = rdata.id;
                }
                this.modalRef = this.modalService.show(
                  this.addtemplate,
                  Object.assign({}, { class: 'gray modal-lg' })
                );

              },
              // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 63 },
            {
              command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 64, title: 'Delete',
              iconCssClass: 'fa fa-trash', cssClass: 'red', textCssClass: 'bold',
              action: (e, args) => {
                Swal.fire({
                  title: 'Delete',
                  text: 'Please confirm to delete the record',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                    this.DeleteIncomingBMRequestMaster(args.dataContext);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {

                  }
                })
              },
              // only show command to 'Delete Row' when the task is not completed

            },


          ],
        }
      }

    ]


  }

 
  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };

  loadInComingBMRequestMaster() {
    this.spinner.show();
    let inpValue = new incomingBMRequest();
    inpValue.languageUno = 1033;
    inpValue.id = 0;
    inpValue.userUno = 2;

    this.restBMApi.getInComingBMRequestMaster(inpValue)
      .subscribe(data => {
        
        this.searchText = '';
        this.data = uniqBy(data, 'id');
        const mockDataset = [];
        for (let i = 0; i < this.data.length; i++) {
         
            mockDataset[i] = {
              id: this.data[i].id,
              incidentNo: this.data[i].incidentNo,
              prNumber: this.data[i].prNumber,
              kpiName: this.data[i].kpiName,
              kpiDescr: this.data[i].kpiDescr,
              kpiFormula: this.data[i].kpiFormula,
              kpiRepVehicle: this.data[i].kpiRepVehicle,
              targetGeoArea: this.data[i].targetGeoArea,
              reasonforKPISelection: this.data[i].reasonforKPISelection,
              ownerPRNumber: this.data[i].ownerPRNumber,
              status: this.data[i].status,
              enteredBy: this.data[i].enteredBy,
              enteredOn: this.data[i].enteredOn,

            };
        }
        this.dataset = mockDataset;
        if (mockDataset.length > 0) {
          this.setGridIncomingBMRequestMasterDefn();
        }
        else {
          this.setGridIncomingBMRequestMasterDefn();
        }
        this.loading = false;
        this.spinner.hide()
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }


  openModalWithClass(addtemplate: TemplateRef<any>) {
    
    this.pageAction == "add";
    this.objIncomingRequest = new incomingBMRequest();

    this.modalRef = this.modalService.show(
      addtemplate,
      Object.assign({}, { class: 'gray modal-lg' })
    );
  }

  onSubmit(val1) {
    
    if (!val1) {
      this.toaster.show('error', 'Error', 'Please enter the required information');
      return
    }

    else {
      this.AddEditIncomingBMRequestMaster(this.objIncomingRequest)
    }
  }

  AddEditIncomingBMRequestMaster(data1: any) {
    
   
    //if (this.DuplicateNameCheck(this.utilityService.isNumericNull(data1.id), this.utilityService.isStringNull(data1.bmProgressName), '')) {
    //  Swal.fire('Error', 'Duplicates are not allowed', 'warning');
    //  return false;
    //}

    let obj = new incomingBMRequest();
    obj = data1;
    obj.id = (this.editID) ? this.editID : 0;
    obj.kpiName = this.objIncomingRequest.kpiName;
    obj.kpiDescr = this.objIncomingRequest.kpiDescr
    obj.kpiFormula = this.objIncomingRequest.kpiFormula;
    obj.kpiRepVehicle = this.objIncomingRequest.kpiRepVehicle;
    obj.targetGeoArea = this.objIncomingRequest.targetGeoArea;
    obj.reasonforKPISelection = this.objIncomingRequest.reasonforKPISelection;
    obj.status = this.objIncomingRequest.status;
    obj.incidentNo = '0';
    obj.prNumber = '0';
    obj.ownerPRNumber = '0';
    obj.status = this.objIncomingRequest.status;
    obj.userUno = this.login_UserID;
    this.restBMApi.addEditIncomingBMRequestMaster(obj)
        .subscribe(data => {

          if (data != null && data != undefined && data != '' && data != 'failure') {
            this.toaster.show('success', 'Success', 'Item Saved.');
            setTimeout(() => {
              this.objIncomingRequest = new incomingBMRequest();
              this.spinner.hide();
              this.loadInComingBMRequestMaster();
              this.modalRef.hide();
            }, 500);
           
          }
          else {

            this.toaster.show('error', 'Error', 'Something went wrong');
            this.spinner.hide();

          }



        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();
        });
      return true;
   
  }
  


  DeleteIncomingBMRequestMaster(data1: any) {
    
    let obj = new incomingBMRequest();
    obj.id = data1.id;
    obj.userUno = 2;
    this.restBMApi.deleteInComingBMRequestMaster(obj)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '' && data != 'failure') {
          this.toaster.show('success', 'Success', 'Item Deleted Successfully.');
          this.spinner.hide();
          this.loadInComingBMRequestMaster();
        }
        else {
          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
        }


       
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }


  getBMProgressTypeDD() {

    let inpValue = new benchmarkprogressmaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;
    this.restApi.getBMProgressTypeDD(inpValue)
      .subscribe(data => {

        this.bmProgressTypeDDList = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  
  Reset() {
    this.modalRef.hide();
    setTimeout(() => {
      this.objIncomingRequest = new incomingBMRequest();
      this.pageAction = 'add';
    }, 300);


  }
  searchGrid() {
    if (this.searchText != "") {
      this.dataset = this.data.filter(a =>
        a.kpiName && a.kpiName.toLowerCase().includes(this.searchText)
        || (a.kpiDescr && a.kpiDescr.toLowerCase().includes(this.searchText))
        || (a.kpiFormula && a.kpiFormula.toLowerCase().includes(this.searchText))
        || (a.kpiRepVehicle && a.kpiRepVehicle.toLowerCase().includes(this.searchText))
        || (a.targetGeoArea && a.targetGeoArea.toLowerCase().includes(this.searchText))
        || (a.reasonforKPISelection && a.reasonforKPISelection.toLowerCase().includes(this.searchText))
        || (a.status && a.status.toLowerCase().includes(this.searchText)));
    }
    else
      this.dataset = this.data;
  }
}
